import React from 'react';
import { useBoolean } from 'react-hanger';
import cls from 'classnames';

import Styled from './styled';
import { ItemProps } from '../types';

const Text = (props: ItemProps & { type?: string }) => {
  const {
    className,
    label,
    placeholder,
    name,
    hideCounter,
    value = '',
    maxLength,
    onChange,
    type,
    onBlur,
  } = props;

  const isValChange = useBoolean(false);
  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e, isValChange.value);
    }
  };

  return (
    <Styled.Text className={cls('form-item form-item-text', className)}>
      <label className="form-item-label">{label}</label>
      <div className="form-item-input">
        <input
          placeholder={placeholder || `请输入${label}`}
          maxLength={maxLength || 300}
          type={type || 'text'}
          name={name}
          value={value}
          autoComplete="off"
          onBlur={handleBlur}
          onChange={(e) => {
            isValChange.setTrue();
            return onChange(name, e.target.value);
          }}
        />
        {!hideCounter && maxLength > 0 && (
          <span className="form-item-counter">
            {value.length}/{maxLength}
          </span>
        )}
      </div>
    </Styled.Text>
  );
};

export default Text;
